import { all, takeEvery, put, call, select } from "redux-saga/effects";
import actions from "./actions";
import profileActions from "../profile/actions";
import * as services from "./services";

const getProfileState = (state) => state.profile;

export function* HIDE_SHOW_MUSIC({ payload }) {
  const { currentUser } = yield select(getProfileState);
  const { hiddenList, musicHidden, videoHidden } = payload;
  yield put({
    type: actions.SET_STATE,
    payload: { loading: true },
  });
  // set music hidden
  yield call(
    services.setMusicHidden,
    currentUser.uid,
    musicHidden,
    videoHidden
  );

  // hide music
  for (let i = 0; i < hiddenList.length; i++) {
    yield call(services.hideMusic, hiddenList[i]);
  }
  yield put({
    type: actions.SET_STATE,
    payload: { loading: false },
  });
  yield put({
    type: profileActions.GET_CURRENT_USER,
    payload: { uid: currentUser.uid },
  });
}

export function* CREATE_NEW_ACHIEVEMENT({ payload }) {
  const { currentUser } = yield select(getProfileState);
  yield put({
    type: actions.SET_STATE,
    payload: { loading: true },
  });
  yield call(services.createNewAchievement, currentUser.uid, payload);
  yield put({
    type: actions.SET_STATE,
    payload: { loading: false },
  });
  yield put({
    type: profileActions.GET_ALL_ACHIEVEMENTS
  })
  // TODO: call get achievements
}

export function* UPDATE_USER_DETAILS({ payload }) {
  const { currentUser } = yield select(getProfileState);
  yield put({
    type: actions.SET_STATE,
    payload: { loading: true },
  });

  let profileImageUrl = currentUser?.profileImageUrl;
  if (payload.profileImage) {
    profileImageUrl = yield call(services.uploadImage, payload.profileImage);
  }
  let coverImageUrl = currentUser.coverImageUrl;
  if (payload.coverImage) {
    coverImageUrl = yield call(services.uploadImage, payload.coverImage);
  }

  let setFirstName= currentUser.firstName;
  if (payload.firstName) {
    setFirstName = yield call(services.updateUserDetails, payload.firstName);
  }

  delete payload.coverImage;
  delete payload.profileImage;
  payload.coverImageUrl = coverImageUrl;
  payload.profileImageUrl = profileImageUrl;
  yield call(services.updateUserDetails, currentUser.uid, payload);
  yield put({
    type: actions.SET_STATE,
    payload: { loading: false },
  });
  yield put({
    type: profileActions.GET_CURRENT_USER,
    payload: { uid: currentUser.uid },
  });
  // TODO: call get achievements
}

export function* HIDE_SHOW_ACHIEVEMENT({ payload }) {
  const { currentUser } = yield select(getProfileState);
  const { hiddenList, achievementHidden } = payload;
  yield put({
    type: actions.SET_STATE,
    payload: { loading: true },
  });
  // setAchivementHidden
  yield call(services.setAchivementHidden, currentUser.uid, achievementHidden);
  // hide music
  for (let i = 0; i < hiddenList.length; i++) {
    yield call(services.hideAchievement, currentUser.uid, hiddenList[i]);
  }
  yield put({
    type: actions.SET_STATE,
    payload: { loading: false },
  });
  yield put({
    type: profileActions.GET_CURRENT_USER,
    payload: { uid: currentUser.uid },
  });
}

export function* CONNECT_LINK({ payload }) {
  const { currentUser } = yield select(getProfileState);
  yield put({
    type: actions.SET_STATE,
    payload: { loading: true },
  });

  yield call(services.connectLink, currentUser.uid, payload);
  yield put({
    type: actions.SET_STATE,
    payload: { loading: false },
  });

  yield put({
    type: profileActions.GET_CURRENT_USER,
    payload: { uid: currentUser.uid },
  });
}

export function* UPDATE_USER_INFOS({ payload }) {
  yield put({
    type: actions.SET_STATE,
    payload: { loading: false },
  });
  const { currentUser } = yield select(getProfileState);
  let resp = true;
  if (currentUser.email !== payload.email) {
    resp = yield call(services.updateUserEmail, payload.email);
    if (resp) {
      yield call(services.updateUserDetails, currentUser.uid, payload);
    }
  } else {
    yield call(services.updateUserDetails, currentUser.uid, payload);
  }
  yield put({
    type: actions.SET_STATE,
    payload: { loading: false },
  });

  yield put({
    type: profileActions.GET_CURRENT_USER,
    payload: { uid: currentUser.uid },
  });
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.HIDE_SHOW_MUSIC, HIDE_SHOW_MUSIC),
    takeEvery(actions.CREATE_NEW_ACHIEVEMENT, CREATE_NEW_ACHIEVEMENT),
    takeEvery(actions.UPDATE_USER_DETAILS, UPDATE_USER_DETAILS),
    takeEvery(actions.HIDE_SHOW_ACHIEVEMENT, HIDE_SHOW_ACHIEVEMENT),
    takeEvery(actions.CONNECT_LINK, CONNECT_LINK),
    takeEvery(actions.UPDATE_USER_INFOS, UPDATE_USER_INFOS),
  ]);
}
